import styled from 'styled-components'

import {
    RowFlex,
    FlexCentered,
    ColumnFlex,
} from 'components/common/genericStyles'
import { EndCallButtonStyle as _EndCallButtonStyle } from 'components/Controls/styles'
import { Color } from 'constants/color'

export const ChatIcon = styled.img`
    width: 20px;
    height: 20px;
`

export const Wrapper = styled.div`
    ${RowFlex};
    ${FlexCentered};

    position: relative;

    width: 50px;
    height: 40px;
    background: ${Color.unknownColor19};
    padding: 12px 16px;
    margin-top: 0 !important;
    margin: 0;
    border-radius: 44px;
    cursor: pointer;
`
